// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__a3Yy6","boxTitle":"Qualiphy_boxTitle__3NHFS","box":"Qualiphy_box__3pMax","toggleWrap":"Qualiphy_toggleWrap__3GLrF"};